import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IBooking } from 'app/shared/model/booking.model';
import { getEntities as getBookings } from 'app/entities/booking/booking.reducer';
import { IBookingUser } from 'app/shared/model/booking-user.model';
import { getEntity, updateEntity, createEntity, reset } from './booking-user.reducer';
import { IActivity } from 'app/shared/model/activity.model';
import { getEntities as getActivities } from 'app/entities/activity/activity.reducer';

export const BookingUserUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const activities = useAppSelector(state => state.activity.entities);
  const bookings = useAppSelector(state => state.booking.entities);
  const bookingUserEntity = useAppSelector(state => state.bookingUser.entity);
  const loading = useAppSelector(state => state.bookingUser.loading);
  const updating = useAppSelector(state => state.bookingUser.updating);
  const updateSuccess = useAppSelector(state => state.bookingUser.updateSuccess);

  const handleClose = () => {
    navigate('/booking-user' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
    dispatch(getActivities({}));
    dispatch(getBookings({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...bookingUserEntity,
      ...values,
      activities: mapIdList(values.activities),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bookingUserEntity,
          activities: bookingUserEntity?.activities?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.bookingUser.home.createOrEditLabel" data-cy="BookingUserCreateUpdateHeading">
            <Translate contentKey="activitiesApp.bookingUser.home.createOrEditLabel">Create or edit a BookingUser</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="booking-user-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.bookingUser.title')}
                id="booking-user-title"
                name="title"
                data-cy="title"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingUser.firsName')}
                id="booking-user-firsName"
                name="firsName"
                data-cy="firsName"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingUser.lastName')}
                id="booking-user-lastName"
                name="lastName"
                data-cy="lastName"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingUser.email')}
                id="booking-user-email"
                name="email"
                data-cy="email"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingUser.mobileNumber')}
                id="booking-user-mobileNumber"
                name="mobileNumber"
                data-cy="mobileNumber"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingUser.sprcialRequirements')}
                id="booking-user-sprcialRequirements"
                name="sprcialRequirements"
                data-cy="sprcialRequirements"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingUser.state')}
                id="booking-user-state"
                name="state"
                data-cy="state"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingUser.activity')}
                id="booking-user-activity"
                data-cy="activity"
                type="select"
                multiple
                name="activities"
              >
                <option value="" key="0" />
                {activities
                  ? activities.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/booking-user" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BookingUserUpdate;
